function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import { BottomSheetContentLayout, MenuItem, PopoverOnHover, Row, Typography, useDevice, useOverlayContext } from 'seagull';
import { Logout24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from "../../../constants";
import { useStore, useStoreActions } from "../../../contexts";
import { useEventReporter } from "../../../event-reporter/EventReporter";
import { UserRole } from "../../../models";
import { selectors } from "../../../store/state-selectors";
import { InitialsAvatar } from "./InitialsAvatar";
import styles from "./UserMenu.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const Separator = () => /*#__PURE__*/_jsx("div", {
  className: styles.separator
});
export const GetUserMenuTID = parentTestId => getTestIds({
  parentTestId,
  deprecatedTestIds: {
    UserMenuTestIds: {
      SettingsButton: 'home-sidebar-settings-btn',
      Avatar: 'home-sidebar-avatar',
      OverflowMenu: 'home-sidebar-avatar-overflow-menu',
      Logout: 'home-sidebar-logout',
      MenuItem: id => "home-sidebar-".concat(id)
    }
  }
});
export const userMenuRoutes = [{
  id: routes.profile,
  text: 'Profile',
  url: routes.profile,
  shouldShow: true
}, {
  id: routes.anchorBilling,
  text: 'Anchor billing',
  url: routes.anchorBilling,
  shouldShow: _ref => {
    let {
      isVendor,
      role
    } = _ref;
    return isVendor && role !== UserRole.Member;
  }
}, {
  id: routes.importAgreements,
  text: 'Import agreements',
  url: routes.importAgreements,
  shouldShow: _ref2 => {
    let {
      isVendor
    } = _ref2;
    return isVendor;
  },
  hideOnMobile: true
}];
export default function UserMenu(props) {
  const {
    userInfo,
    testId
  } = props;
  const {
    UserMenuTestIds
  } = useMemo(() => GetUserMenuTID(testId), [testId]);
  const {
    isMobileDevice
  } = useDevice();
  const {
    showBottomSheet,
    hideBottomSheet
  } = useOverlayContext();
  const userInitials = userInfo.userInitials();
  const history = useHistory();
  const {
    reset
  } = useStoreActions();
  const {
    sendEventToGtm
  } = useEventReporter();
  const filteredUserMenuRoutes = userMenuRoutes.filter(route => isMobileDevice ? !route.hideOnMobile : true);
  const topbarLinks = useStore(selectors.filterAvailableRoutes(filteredUserMenuRoutes));
  function renderTrigger(triggerProps) {
    return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
      "data-testid": UserMenuTestIds.SettingsButton()
    }, triggerProps), {}, {
      children: /*#__PURE__*/_jsx(InitialsAvatar, {
        userInitials: userInitials,
        "data-testid": UserMenuTestIds.Avatar(),
        isActive: triggerProps['data-popover-is-open'] === 'true'
      })
    }));
  }
  function renderContent(_ref3) {
    let {
      onCloseMenu
    } = _ref3;
    const userName = userInfo.fullName();
    const userEmail = userInfo.email();
    const wrapper = children => isMobileDevice ? /*#__PURE__*/_jsx(BottomSheetContentLayout, {
      header: {
        title: userName,
        subtitle: userEmail
      },
      children: children
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.avatarContainer,
        children: [/*#__PURE__*/_jsx(InitialsAvatar, {
          userInitials: userInitials
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Typography, {
            weight: "normal",
            children: userName
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph3",
            skin: "secondary",
            children: userEmail
          })]
        })]
      }), children]
    });
    return /*#__PURE__*/_jsx("div", {
      className: cn(styles.root, {
        [styles.mobile]: isMobileDevice
      }),
      "data-testid": UserMenuTestIds.OverflowMenu(),
      children: wrapper( /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Separator, {}), topbarLinks.map(_ref4 => {
          let {
            text,
            url,
            id
          } = _ref4;
          return /*#__PURE__*/_jsx(MenuItem, {
            skin: "secondary",
            testId: UserMenuTestIds.MenuItem(id),
            onClick: () => {
              history.push(url);
              onCloseMenu();
            },
            children: text
          }, id);
        }), /*#__PURE__*/_jsx(Separator, {}), /*#__PURE__*/_jsx(MenuItem, {
          skin: "secondary",
          testId: UserMenuTestIds.Logout(),
          onClick: () => {
            sendEventToGtm('logout', {});
            reset(true);
            history.push(routes.home);
            onCloseMenu();
          },
          children: /*#__PURE__*/_jsxs(Row, {
            gap: 12,
            alignItems: "center",
            children: [/*#__PURE__*/_jsx(Logout24, {}), "Log out"]
          })
        })]
      }))
    });
  }
  return isMobileDevice ? renderTrigger({
    onClick: () => showBottomSheet({
      content: renderContent({
        onCloseMenu: () => hideBottomSheet()
      })
    })
  }) : /*#__PURE__*/_jsx(PopoverOnHover, {
    placement: "bottom-end",
    openStrategy: "click",
    removePadding: true,
    showArrow: true,
    trigger: renderTrigger,
    content: _ref5 => {
      let {
        closePopover
      } = _ref5;
      return renderContent({
        onCloseMenu: () => closePopover()
      });
    }
  });
}